import './SpellListItem.scss';
import { SCHOOLS } from '../../data';
import { Icon, Pill, Row } from '..';
import { canUpcast, compactTimeDisplay, componentsCompactDisplay, getSpellId, isConc, isRitual } from '../../util/spell';
import { useNavigate } from 'react-router-dom';
import { useWideMode } from '../../hooks';
import { Checkbox } from '../Checkbox/Checkbox';

export const SpellListItem = ({ 
    addable = false,
    added = false,
    onAdd = () => {},
    onRemove = () => {},
    checkable = false, 
    checked = false,
    onCheck = () => {},
    spell 
}) => {
    const isWide = useWideMode();
    const navigate = useNavigate();

    const handleClick = () => {
        if (isWide) {
            navigate(`?spellId=${getSpellId(spell)}`);
        } else {
            navigate(`/${getSpellId(spell)}`);
        }
    };

    const handleCheck = (e) => {
        onCheck();
        e.stopPropagation();
    };

    const handleAddRemove = (e) => {
        if (!addable) return;

        if (added) onRemove();
        else onAdd();

        e.stopPropagation();
    };

    return (
        <Row className='SpellListItem' onClick={handleClick}>
            {checkable && 
                <Checkbox 
                    checked={checked}
                    onCheck={handleCheck}
                />
            }
            <Pill className='level'>{spell.level}{canUpcast(spell) && <span>+</span>}</Pill>
            <Pill className='school'>{SCHOOLS[spell.school].slice(0,4).toUpperCase()}</Pill>
            {isRitual(spell) ? <Pill style={{width: 25}}>R</Pill> : <div style={{width: 25}} />}
            {isConc(spell) ? <Pill style={{width: 25}}>C</Pill> : <div style={{width: 25}} />}
            <Pill className='castingTime'><Icon name="clock" size={13} />{compactTimeDisplay(spell)}</Pill>
            <div className='name'>{spell.name}</div>
            <Pill className='components'>{componentsCompactDisplay(spell)}</Pill>
            <Pill className='source'>{spell.source}</Pill>
            {addable && 
                <Icon 
                    size='1.5rem'
                    className="plusminus"
                    color={added ? '#e76f51': '#2a9d8f'}
                    name={`circle-${added ? 'minus' : 'plus'}`}
                    onClick={handleAddRemove}
                />
            }
        </Row>
    );
};